const rail = {
  rails: "פסי רכבת", // translated
  senior: "בָּכִיר", // translated
  seniors: "קשישים", // translated
  youths: "בני נוער", // translated
  yearOld: "גיל", // translated
  yearsOld: "שנים", // translated
};

export default rail;
